import { apiUrls, AuthOpeningOpenBaseParam } from 'shared/entities/domain';
import { Bucket } from 'shared/entities/bucket';
import { SmartIds } from 'shared/entities/network';
import { INetworkStore } from 'shared/entities/store/networkStore';
import {
  mapBaseErrorCodeToScenarioErrorToMessage,
  ScenarioCommonServer,
  ScenarioPreset
} from 'shared/entities/scenario';

/**
 * Если строка начинается с "template_" и далее следует валидное значение ScenarioPreset,
 * возвращает соответствующий пресет, иначе возвращает null.
 */
export const getScenarioPresetFromOpeningParam = (
  openParam: AuthOpeningOpenBaseParam
): ScenarioPreset | null => {
  if (!openParam.startsWith('template_')) {
    return null;
  }

  const preset = openParam.substring('template_'.length);

  return Object.values(ScenarioPreset).includes(preset as ScenarioPreset)
    ? (preset as ScenarioPreset)
    : null;
};

export const getOpeningTemplateId = async (
  { preset, projectId }: { preset: ScenarioPreset; projectId: string },
  networkStore: INetworkStore
): Promise<BaseResponse<{ id: string }>> => {
  const response = await networkStore.api<{ template: ScenarioCommonServer }>(
    apiUrls.TEMPLATES_GET,
    {
      method: 'GET',
      data: {
        preset,
        [SmartIds.bucket]: Bucket.prod,
        projectId
      },
      errorsMap: mapBaseErrorCodeToScenarioErrorToMessage
    }
  );

  if (response.isError) {
    return {
      isError: true
    };
  }

  return {
    isError: false,
    data: { id: response.data.template._id }
  };
};
